export default __webpack_public_path__ + "static/media/top_w992up_3.c9f9d681.png";